import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Stack from "components/common/Stack";
import CKYCauto from "components/Onboarding/CKYCauto";
import CKYCmanual from "components/Onboarding/CKYCmanual";

// import MenuItem from "components/common/MenuItem";

import { validationHelper } from "helper/validation";
import JarvisButton from "components/JarvisButton";
import { dateTimeHelper } from "helper/dateTime";
import { cameraHelper } from "helper/camera";

import { jarvisRMSOnboardingApis } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingApis";
import { masterApis } from "stores/master/masterApis";
import { config } from "config/index";
import { localStore } from "stores/localStorage";
import { jarvsiRMSOnboardingActions } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingAction";
import { resolveCkycFormData } from "helper/ckycPrefill";
import {
  buildKycUploadUpdate,
  buildMergedKycUploadDisplayState,
  emptyCkycDocStatus,
  kycDocumentUploadSucceeded,
  mergeCkycDocStatusWithUploadFlags,
  ckycStatusFlagsFromProps,
  didCkycVerificationChange,
} from "helper/kycDocumentUpload";
import {
  applyCkycUploadFailure,
  applyCkycUploadResult,
  areKycDocumentsReadyForSubmit,
  getCkycCustomerName,
  getKycUploadCatchMessage,
  isManualKycVerified,
  requestCkycDocumentVerify,
  validateKycDocumentUpload,
} from "helper/ckycDocumentVerify";

class RMSCkycContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        panNumber: "",
        aadharNumber: "",
        dateOfBirth: "",
        inputIdType: "C",
      },
      manageForm: {
        docType: "",
        docVerify: false,
      },
      formError: {
        aadharNumber: "",
        panNumber: "",
        dateOfBirth: "",
        panCard: "",
        aadharCardFront: "",
        aadharCardBack: "",
      },

      imagesUploadingLoader: {
        panCard: false,
        aadharCardFront: false,
        aadharCardBack: false,
      },

      localUploads: {
        panCard: false,
        aadharCardFront: false,
        aadharCardBack: false,
      },

      documentVerifyStatus: mergeCkycDocStatusWithUploadFlags(
        emptyCkycDocStatus(),
        ckycStatusFlagsFromProps(props),
      ),

      isVerified: false,
      isLoading: false,

      enableManually: true,
      hasFirstAttempError: false,
    };
    this.ckycUploadApplied = false;
  }

  syncCkycFormFromProps = () => {
    const { loginProfile, panNumber, dateOfBirth, aadharNumber } = this.props;
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        ...resolveCkycFormData(
          loginProfile,
          { panNumber, dateOfBirth, aadharNumber },
          prev.formData,
        ),
      },
    }));
  };

  async componentDidMount() {
    if (
      localStore.isSsoCustomer() &&
      localStore.getSsoCustomerDetails()?.brokerName ===
      config.broker.ssoPlatform.centrum
    ) {
      this.props.history.replace({
        pathname: "/customer/document-signing",
        state: {
          returnURI: "/jarvis-rms/dashboard",
          callOrigin: "JARVIS_RMS",
          productCode: config.productCodes.RMS,
        },
      });
    }
    const isSsoCustomer = localStore.isSsoCustomer();
    const {
      currentStage,
      panNumber,
      dateOfBirth,
      aadharNumber,
      isPanUploaded,
      isAadhaarFrontUploaded,
      isAadhaarBackUploaded,
      tempCustomerPortfolioId,
      isRMSOnboardingCompleted,
    } = this.props;
    if (
      currentStage === "CKYC" &&
      tempCustomerPortfolioId &&
      !isRMSOnboardingCompleted
    ) {
      jarvisRMSOnboardingApis.confirmPortfolioStock({
        portfolioId: tempCustomerPortfolioId,
      });
    }

    this.props.getRMSOnboardingDataAction();
    this.syncCkycFormFromProps();

    if (currentStage === "DOCUMENT_SIGNING") {
      this.setState((prev) => ({
        formData: {
          ...prev.formData,
          ...resolveCkycFormData(
            this.props.loginProfile,
            { panNumber, dateOfBirth, aadharNumber },
            prev.formData,
          ),
        },
        isVerified: true,
      }));
    }
    if (
      currentStage === "CKYC" &&
      (isPanUploaded || isAadhaarFrontUploaded || isAadhaarBackUploaded)
    ) {

      this.setState({ enableManually: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.panNumber !== this.props.panNumber ||
      prevProps.dateOfBirth !== this.props.dateOfBirth ||
      prevProps.aadharNumber !== this.props.aadharNumber ||
      prevProps.loginProfile !== this.props.loginProfile ||
      (prevProps.currentStage !== this.props.currentStage &&
        this.props.currentStage === "CKYC")
    ) {
      this.syncCkycFormFromProps();
    }

    if (prevProps.currentStage !== this.props.currentStage) {
      this.setState({
        isVerified: this.props.currentStage === "DOCUMENT_SIGNING",
      });
    }

    if (didCkycVerificationChange(prevProps, this.props) && !this.ckycUploadApplied) {
      this.setState((prev) => ({
        documentVerifyStatus: mergeCkycDocStatusWithUploadFlags(
          prev.documentVerifyStatus,
          ckycStatusFlagsFromProps(this.props),
        ),
      }));
    }
  }

  toggleKYCtype = (val) => {
    this.setState({ enableManually: val });
  };

  handleChange = ({ name, value }) => {
    if (name === "docType") {
      this.setState((prev) => ({
        manageForm: { ...prev.manageForm, [name]: value },
      }));
      return;
    }
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
      formError: { ...prev.formError, [name]: "" },
    }));
  };

  handleValidation = () => {
    const { formError, formData } = this.state;

    const panValidation = validationHelper.pan(formData.panNumber);
    formError.panNumber = panValidation.message;

    const dobValidation = validationHelper.dateOfBirth(formData.dateOfBirth);
    formError.dateOfBirth = dobValidation.message;

    this.setState({ formError });
    return panValidation.isValid && dobValidation.isValid;
  };

  //Verification Click
  handleVerification = async () => {
    if (!this.handleValidation()) {
      return;
    }

    const { formData, currentStage } = this.state;
    this.setState({ isLoading: true, hasFirstAttempError: false });

    try {
      const res = await masterApis.verfyAutoKYC({
        dateOfBirth: dateTimeHelper.dateOfBirth(formData.dateOfBirth),
        pan: formData.panNumber,
      });

      if (res.code == "KYC009") {
        await masterApis.submitKYCApi({ productCode: "RMS" });
        this.setState({ isVerified: true }, () => {
          this.props.getRMSOnboardingDataAction();
        });
        // await jarvisRMSOnboardingApis.confirmRMSCKYCData();
      } else {
        this.setState({ hasFirstAttempError: true });
      }
    } catch (e) {
      this.setState({ hasFirstAttempError: true });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleValidationReVerification = () => {
    const { formError, formData, localUploads, documentVerifyStatus } = this.state;
    const { disableUpload } = this.props;

    const panValidation = validationHelper.pan(formData.panNumber);
    formError.panNumber = panValidation.message;

    const dobValidation = validationHelper.dateOfBirth(formData.dateOfBirth);
    formError.dateOfBirth = dobValidation.message;

    const aadharValidation = validationHelper.aadhar(formData.aadharNumber);
    formError.aadharNumber = aadharValidation.message;

    const isImagesUploaded = buildMergedKycUploadDisplayState(
      {
        isPanUploaded: this.props.isPanUploaded,
        isAadhaarFrontUploaded: this.props.isAadhaarFrontUploaded,
        isAadhaarBackUploaded: this.props.isAadhaarBackUploaded,
      },
      this.props.crossProductKycUploadFlags,
      localUploads,
    );

    if (!areKycDocumentsReadyForSubmit(isImagesUploaded, disableUpload, documentVerifyStatus)) {
      formError.panCard = !isImagesUploaded.panCard ? "Verify PAN photo" : "";
      formError.aadharCardFront = !isImagesUploaded.aadharCardFront
        ? "Verify Aadhaar Front"
        : "";
      formError.aadharCardBack = !isImagesUploaded.aadharCardBack
        ? "Upload Aadhaar Back"
        : "";
      this.setState({ formError });
      return false;
    }

    formError.panCard = "";
    formError.aadharCardFront = "";
    formError.aadharCardBack = "";
    this.setState({ formError });
    return (
      panValidation.isValid && dobValidation.isValid && aadharValidation.isValid
    );
  };

  // Re-verification Click
  handleReVerification = async () => {
    if (!this.handleValidationReVerification()) {
      return;
    }

    const { formData } = this.state;
    this.setState({ isLoading: true, hasFirstAttempError: false });

    try {
      const res = await masterApis.verifyManualKyc({
        panNumber: formData.panNumber,
        aadhaarNumber: formData.aadharNumber,
        dateOfBirth: formData.dateOfBirth,
        productCode: config.productCodes.RMS,
      });

      if (isManualKycVerified(res)) {
        this.setState(
          { isVerified: true, enableManually: true },
          () => { }
        );
        this.props.updateRMSOnboardingData({
          isManualKYC: res.result?.isVerified,
        });
        this.props.getRMSOnboardingData();
      } else {
        this.props.setToast({ message: res.message });
      }
    } catch (e) {
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleProceedDocumentSigningClick = async () => {
    let pathname = "/customer/document-signing";
    if (this.props.loginProfile.isManualAgreement === 1) {
      pathname = "/manual-document-signing";
    }
    this.props.history.push({
      pathname: pathname,
      state: {
        returnURI: "/jarvis-rms/existing-holding",
        callOrigin: "JARVIS_RMS",
        productCode: config.productCodes.RMS,
      },
    });
  };
  readFileAsBlob = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // Define onload event handler
      reader.onload = function (event) {
        const fileContent = event.target.result;
        const blob = new Blob([fileContent], { type: file.type });
        resolve(blob); // Resolve with the result when reading is complete
      };

      // Define onerror event handler
      reader.onerror = function (event) {
        reject(event.target.error); // Reject with the error if reading fails
      };

      // Start reading the file
      reader.readAsArrayBuffer(file);
    });
  };
  //   Uploading Image
  onBrowseClick = async ({ type, data = null, source } = {}) => {
    const customerName = getCkycCustomerName(this.props.loginProfile);
    const fieldValidation = validateKycDocumentUpload({
      type,
      formData: this.state.formData,
      customerName,
    });
    if (!fieldValidation.isValid) {
      this.setState((prev) => ({
        formError: {
          ...prev.formError,
          ...fieldValidation.errors,
        },
      }));
      if (fieldValidation.errors.customerName) {
        this.props.setToast({ message: fieldValidation.errors.customerName });
      }
      return;
    }

    let fileData = data;
    if (fileData?.name) {
      const fileName = fileData.name;
      const fileExtension = fileName.split(".").pop().toLowerCase();
      fileData.format = fileExtension;
    }

    const isNativeCamera =
      config.platform !== "WEB" && source === "camera";
    if (isNativeCamera) {
      fileData = await cameraHelper.getKycNativeDocumentPhoto();
    }

    if (!fileData) {
      return;
    }

    let file;
    if (isNativeCamera) {
      file = await cameraHelper.getBlobFromCameraPhoto(fileData);
      if (!file || file.size === 0) {
        this.props.setToast({
          message: "Could not read the photo. Please try again.",
        });
        return;
      }
    } else {
      file = await this.readFileAsBlob(fileData);
      if (!file || file.size === 0) {
        this.props.setToast({
          message:
            "Could not read the selected file. Please try again.",
        });
        return;
      }
    }

    const uploadExt = cameraHelper.extensionForKycUpload(fileData);

    const fileKB = file.size / 1024; // Converted in KB.
    if (fileKB > 10000) {
      const fileMB = (fileKB / 1000).toFixed(2);

      // if images are more than 10mb
      this.props.setToast({
        message: `Image must be less than 10MB, your Uploaded image is ${fileMB} MB`,
      });
      return;
    }
    this.setImagesUploadingLoader(type, true);
    try {
      const res = await requestCkycDocumentVerify({
        type,
        file,
        fileName: `${type}_${this.props.loginProfile.customerId}_${dateTimeHelper
          .now()
          .getTime()}.${uploadExt}`,
        originalFileName: fileData?.name,
        productCode: config.productCodes.RMS,
        loginProfile: this.props.loginProfile,
        formData: this.state.formData,
      });

      const succeeded = kycDocumentUploadSucceeded(res, type);

      this.ckycUploadApplied = true;
      this.setState((prev) => ({
        ...applyCkycUploadResult(prev, type, res),
        localUploads: {
          ...prev.localUploads,
          [type]: succeeded,
        },
      }));

      this.props.updateRMSOnboardingData(
        buildKycUploadUpdate(
          {
            isPanUploaded: this.props.isPanUploaded,
            isAadhaarFrontUploaded: this.props.isAadhaarFrontUploaded,
            isAadhaarBackUploaded: this.props.isAadhaarBackUploaded,
          },
          type,
          res,
        ),
      );
    } catch (e) {
      this.setState((prev) => ({
        ...applyCkycUploadFailure(prev, type, getKycUploadCatchMessage(e), e),
        localUploads: {
          ...prev.localUploads,
          [type]: false,
        },
      }));
    } finally {
      this.setImagesUploadingLoader(type, false);
    }
  };

  setImagesUploadingLoader = (type, value) => {
    this.setState(prev => ({
      imagesUploadingLoader: {
        ...prev.imagesUploadingLoader,
        [type]: value,
      },
    }));
  };


  render() {
    const {
      formData,
      formError,
      isVerified,
      isLoading,
      enableManually,
      imagesUploadingLoader,
      hasFirstAttempError,
      localUploads,
      documentVerifyStatus,
    } = this.state;

    const {
      isPanUploaded,
      isAadhaarFrontUploaded,
      isAadhaarBackUploaded,
      crossProductKycUploadFlags,
      disableUpload,
    } = this.props;

    const isImagesUploaded = buildMergedKycUploadDisplayState(
      {
        isPanUploaded,
        isAadhaarFrontUploaded,
        isAadhaarBackUploaded,
      },
      crossProductKycUploadFlags,
      localUploads,
    );
    return (
      <>
        <Stack sx={{ flex: 1 }}>
          {enableManually ? (
            <CKYCmanual
              formData={formData}
              formError={formError}
              isVerified={isVerified}
              isLoading={isLoading}
              isImagesUploaded={isImagesUploaded}
              imagesUploadingLoader={imagesUploadingLoader}
              handleChange={this.handleChange}
              onBrowseClick={this.onBrowseClick}
              handleReVerification={this.handleReVerification}
              toggleKYCtype={this.toggleKYCtype}
              disableUpload={disableUpload}
              documentVerifyStatus={documentVerifyStatus}
              isPanUploaded={this.props.isPanUploaded}
              isAadhaarFrontUploaded={this.props.isAadhaarFrontUploaded}
              isAadhaarBackUploaded={this.props.isAadhaarBackUploaded}
            />
          ) : (
            // CKYC Auto
            <CKYCauto
              formData={formData}
              formError={formError}
              isVerified={isVerified}
              isLoading={isLoading}
              hasFirstAttempError={hasFirstAttempError}
              handleChange={this.handleChange}
              handleVerification={this.handleVerification}
              toggleKYCtype={this.toggleKYCtype}
            />
          )}
          {isVerified ? (
            <Stack
              direction="row"
              justifyContent={{ xs: "center", md: "flex-start" }}
              mb={3}
              mt={6}
              alignItems="center"
              sx={{ width: { xs: "100%", md: "auto" }, background: "#fff" }}
            >
              <Stack
                sx={{
                  position: { xs: "fixed", md: "unset" },
                  bottom: {
                    xs: "calc(10px + var(--safe-area-inset-bottom)) !important",
                    md: "unset",
                  },
                  width: { xs: "90vw", md: "unset" },
                }}
              >
                <JarvisButton
                  loading={isLoading}
                  onClick={this.handleProceedDocumentSigningClick}
                  sx={{ width: { xs: "100%", md: "auto" } }}
                >
                  Proceed to Client Agreement
                </JarvisButton>
              </Stack>
            </Stack>
          ) : null}
        </Stack>
      </>
    );
  }
}
export default withRouter(RMSCkycContainer);
